<template>
    <AppNavigation>
        <mdb-container fluid>
            <mdb-row class="mb-3">
                <mdb-col col="1" v-if="this.$route.params.id" class="d-flex flex-center">
                    <mdb-btn @click="$router.back()" size="sm" color="primary"><i class="fas fa-arrow-left"></i></mdb-btn>
                </mdb-col>
                <mdb-col col="11">
                    <h1 class="h1-responsive">Rider Transactions</h1>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col md="2">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="date_from" label="Date From" />
                    </div>
                </mdb-col>
                <mdb-col md="2">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true"  v-model="date_to" label="Date To" />
                    </div>
                </mdb-col>
                <mdb-col md="3" class="d-flex align-items-center">
                    <!-- <select v-model="rider_select" class="browser-default custom-select">
                        <option value="">All Rider</option>
                        <option v-for="partner in partners" v-bind:key="partner.id" :value="partner.partner_profile.id">[ {{partner.partner_profile.partner_code}} ] - {{partner.partner_profile.fullname}}</option>
                    </select> -->
                    <multiselect
                    v-model="rider_select"
                    :multiple="true"
                    :close-on-select="false"
                    placeholder="Rider"
                    label="name_std"
                    track-by="name_std"
                    :options="partners">
                    </multiselect>
                </mdb-col>
                <mdb-col md="3" class="d-flex align-items-center">
                    <select v-model="service_type_select" class="browser-default custom-select">
                        <option value="">Service Type</option>
                        <option value="ADMIN_TOPUP">Admin Topup</option>
                        <option value="ADMIN_DEDUCT">Admin Deduct</option>
                        <option value="ADMDISPUTE_PENALTYIN_TOPUP">Dispute Penalty</option>
                        <option value="DISPUTE_COMPENSATE">Dispute Compensate</option>
                        <option value="COD">COD</option>
                        <option value="PB">PB</option>
                        <option value="PARTNER_TOPUP">Rider TopUp</option>
                        <option value="PARTNER_WITHDRAWAL">Rider Withdraw</option>
                    </select>
                </mdb-col>
                <mdb-col md="2" class="d-flex align-items-center">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary" size="sm"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col col="12">
                    <mdb-spinner small v-if="excel_loading" />
                    <mdb-btn outline="info" size="sm" v-if="!loading && !excel_loading" @click="downloadExcel()"><mdb-icon icon="file-excel" /> Download Excel within Duration</mdb-btn>
                </mdb-col>
            </mdb-row>
            <hr>
            <mdb-row>
            </mdb-row>
            <div v-if="loading">Wait.. Processing dont panic...</div>
            <mdb-tbl responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th><div>Ref Number</div></th>
                    <th><div>Order Number</div></th>
                    <th><div>Rider</div></th>
                    <th><div>Service Type</div></th>
                    <th><div>Amount</div></th>
                    <th><div>Status</div></th>
                    <th><div>Date Time</div></th>
                    <th>Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr style="cursor: pointer" v-for="(record, index) in records" :key="record.id">
                    <td>{{index+1}}</td>
                    <td>
                        <div class="font-weight-bold">{{record.ref_number}}</div>
                        <div class="text-danger" style="font-size: 0.8rem">{{record.remark}}</div>
                    </td>
                    <td>
                        <div v-if="record.service_order">{{record.service_order.order_number}}</div>
                        <div v-if="record.ref_number2">{{record.ref_number2}}</div>
                    </td>
                    <td>
                        [ {{record.partner_profile.partner_code}} ] - {{record.partner_profile.fullname}}
                    </td>
                    <td>
                        <div>{{record.service_type}}</div>
                        <div v-if="record.admin">{{record.admin.name}}</div>
                    </td>
                    <td>{{record.amount}}</td>
                    <td>
                        <div class="text-warning font-weight-bold" v-if="record.status=='PENDING'">{{record.status}}</div>
                        <div class="text-success font-weight-bold" v-if="record.status=='APPROVED'">{{record.status}}</div>
                        <div class="text-danger font-weight-bold" v-if="record.status=='REJECTED'">{{record.status}}</div>
                    </td>
                    <td>{{momentFormat16(record.created_at)}}</td>
                    <td>
                        <mdb-btn color="primary" @click="showDetail(record)" size="sm"><mdb-icon far icon="eye" /></mdb-btn>
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <PartnerTransactionDetail :visible="partner_transaction_detail_modal" :close="closeModal" :transaction="focus_record" />
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbBtn, mdbDatePicker, mdbIcon, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
// import {APP_STORAGE_URL} from '../js/config';
import {momentFormat16} from '../js/helper';
import PartnerTransactionDetail from '../components/PartnerTransactionDetail';
import Multiselect from 'vue-multiselect'

export default {
  name: 'partner_wallet_transactions',
  components: {
    mdbContainer, mdbRow, mdbCol, mdbBtn, mdbDatePicker, PartnerTransactionDetail,
    AppNavigation, mdbIcon, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody,
    Multiselect
  },
  data: ()=>({
      date_from: "",
      date_to: "",
      loading:false,
      records: [],
      partner_transaction_detail_modal: false,
      focus_record: null,
      partners: [],
      rider_select: [],
      service_type_select: "",
      excel_loading: false,
      sort_col:3,
      sort_type:"ASC"
  }),
  methods: {
    closeModal(){
        this.partner_transaction_detail_modal=false;
    },
    getData(){
        if(this.loading){
            return false;
        }
        let rider_selected = [];
        this.rider_select.forEach(element => {
            rider_selected.push(element.partner_profile.id);
        });
        this.loading=true;
        ajax({
            url: "admin/get_wallet_transactions",
            data: {
                date_from: this.date_from,
                date_to: this.date_to,
                partner_profile_id: rider_selected,
                service_type: this.service_type_select,
                sort_type:this.sort_type,
                sort_col:this.sort_col
            },
            complete: ()=>this.loading=false,
            success: result=>{
                let records = [...result.data.transactions];
                this.records=records;
            },
        }, this)
    },
    showDetail(record){
        this.focus_record=record;
        this.partner_transaction_detail_modal=true;
    },
    momentFormat16(date){
        return momentFormat16(date);
    },
    downloadExcel(){
        this.excel_loading=true;
        ajax({
            url: "admin/excel_wallet_transactions",
            data: {
                date_from: this.date_from,
                date_to: this.date_to,
            },
            success: ()=>{
                this.$notify.success({message: 'Downloaded Document will be available in few minutes time', position:'top right', timeOut: 5000});
            },
            complete: ()=>this.excel_loading=false,
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    getRiderData(){
        ajax({
            url: "admin/get_partner_list",
            success: result=>{
                let riders = result.data;                
                riders.sort((a, b)=>{
                    if(a.partner_profile.partner_code < b.partner_profile.partner_code) { return -1; }
                    if(a.partner_profile.partner_code > b.partner_profile.partner_code) { return 1; }
                    return 0;
                })
                riders.forEach(element => {
                    element.name_std= `[ ${element.partner_profile.partner_code} ] - ${element.partner_profile.fullname}`;
                    if(this.$route.params.id && this.$route.params.id==element.partner_profile.id){
                        this.rider_select=[element];
                        this.getData();
                    }
                });
                this.partners=riders;
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    sortBy(col){
        if(this.sort_col==col){
            this.sort_type=="ASC"?this.sort_type="DESC":this.sort_type="ASC"
        }else{
            this.sort_type="ASC";
            this.sort_col=col;
        }
        // this.getData();
    }
  },
  mounted: function(){
    let date = new Date();
    let month = date.getMonth()+1;
    this.date_from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.date_to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    if(this.$route.params.date_from){
        this.date_from=this.$route.params.date_from;
    }
     if(this.$route.params.date_to){
        this.date_to=this.$route.params.date_to;
    }
    this.getRiderData();
    if(!this.$route.params.id){
        this.getData();
    }    
  }
}
</script>

<style>
.link-text:hover{
    color: #4285F4;
    cursor: pointer;
}
</style>
